import styled from 'styled-components'

export const Body = styled.div`
  color: ${o => o.theme.color.deprecated.obsidian};
`

export const FitTitle = styled.div`
  width: 100px;
  line-height: 27px;
  font-weight: 500;
`

export const Percentage = styled.div`
  width: 40px;
  text-align: right;
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  margin-left: 10px;
`

export const SurveyWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const FieldsWrap = styled.div`
  margin-top: 12px;

  ${SurveyWrap}:not(:last-child) {
    margin-bottom: 14px;
  }
`

export const ProgressBar = styled.div`
  display: flex;
  flex-grow: 1;
  height: 12px;
  position: relative;
  background: ${o => o.theme.color.deprecated.stone};
`

export const Progress = styled.span<{
  progress: number
}>`
  display: block;
  width: ${o => o.progress}%;
  height: 100%;
  background-color: ${o => o.theme.color.deprecated.obsidian};
  position: relative;
  overflow: hidden;
`

export const Title = styled.span`
  line-height: 27px;
  font-size: 18px;
  font-weight: bold;
`
